import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditServiceTypeData {
  // Pre-filled values when opening the service type form for editing.

  serviceCategoryId: string
  // Parent category id (UUID7).

  description: string
  // Human-readable type description.

  duration: string
  // ISO 8601 duration string (e.g. `PT1H30M`).

  price: number | null
  // Fixed price in major currency units; null when not set.

  priceStart: string
  // Display label for the price-start selector.
}

export const useAddServiceTypeFormStore = defineStore('addServiceTypeForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditServiceTypeData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditServiceTypeData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddServiceTypeFormStore, import.meta.hot))
}
